/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';

export type EpsiDocsSynchronizeCreateRequest = {} | null | undefined;
export type EpsiDocsSynchronizeCreateResponse = any;

export type EpsiDocsSynchronizeCreateQuery = {};

/**
 * POST /dmx-server/epsi_docs/synchronize/
 *
 * ```yaml
 * operationId: epsi_docs_synchronize_create
 * description: |-
 *   Spustí R46 synchronizaci stavových (inicializačních) dat PSPI.
 *
 *   Záměrně jen stavová sada, bez vstupu (datumOd má smysl jen pro změnovou
 *   kotvu) — změnovou synchronizaci pouští cron / command synchronize_pspi.
 *   Po stažení se Georeálu předávají joby ImportStavPSPI po jednom od
 *   nejstaršího otisku (viz start_next_waiting_stav_import). R46 dotaz
 *   a založení EpsiDoc proběhnou synchronně, takže nedostupný IS DMVS vrátí
 *   rovnou 502, ne tichý 202; stahování pak běží na pozadí a průběh je vidět
 *   v listingu (WAITING_FOR_DOWNLOAD → DOWNLOADING → …) a přes SSE kanál
 *   dmx:epsi_docs. Když už stahování stavové sady běží, vrací 409 — jen
 *   spam-ochrana; korektnost při souběhu drží claimy a unique_queued_pspi_day,
 *   DOWNLOADING přes timeout se počítá jako mrtvý běžec a nový běh ho převezme.
 * tags:
 *   - epsi_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '202':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/epsi_docs_synchronize_accepted'
 *     description: >-
 *       Nové stavové sady z R46 zaevidovány (hned viditelné v listingu i v
 *       `created`; nic nového = prázdný seznam), stahování běží na pozadí.
 *   '403':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/epsi_docs_synchronize_detail'
 *     description: Chybí oprávnění — ACL resource `EpsiDocs`, akce `synchronize`.
 *   '409':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/epsi_docs_synchronize_detail'
 *     description: Stahování stavové sady už běží — sledujte stavy v listingu.
 *   '502':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/epsi_docs_synchronize_detail'
 *     description: R46 dotaz na IS DMVS selhal — detail ve worklistu external_failures.
 * ```
 */
export const epsiDocsSynchronizeCreateOperation = (rest?: EpsiDocsSynchronizeCreateQuery | null) =>
  ({
    method: 'POST',
    path: `/dmx-server/epsi_docs/synchronize/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'POST';
    path: string & { _templateUrl: '/dmx-server/epsi_docs/synchronize/' };
  };

/**
 * POST /dmx-server/epsi_docs/synchronize/
 *
 * ```yaml
 * operationId: epsi_docs_synchronize_create
 * description: |-
 *   Spustí R46 synchronizaci stavových (inicializačních) dat PSPI.
 *
 *   Záměrně jen stavová sada, bez vstupu (datumOd má smysl jen pro změnovou
 *   kotvu) — změnovou synchronizaci pouští cron / command synchronize_pspi.
 *   Po stažení se Georeálu předávají joby ImportStavPSPI po jednom od
 *   nejstaršího otisku (viz start_next_waiting_stav_import). R46 dotaz
 *   a založení EpsiDoc proběhnou synchronně, takže nedostupný IS DMVS vrátí
 *   rovnou 502, ne tichý 202; stahování pak běží na pozadí a průběh je vidět
 *   v listingu (WAITING_FOR_DOWNLOAD → DOWNLOADING → …) a přes SSE kanál
 *   dmx:epsi_docs. Když už stahování stavové sady běží, vrací 409 — jen
 *   spam-ochrana; korektnost při souběhu drží claimy a unique_queued_pspi_day,
 *   DOWNLOADING přes timeout se počítá jako mrtvý běžec a nový běh ho převezme.
 * tags:
 *   - epsi_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '202':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/epsi_docs_synchronize_accepted'
 *     description: >-
 *       Nové stavové sady z R46 zaevidovány (hned viditelné v listingu i v
 *       `created`; nic nového = prázdný seznam), stahování běží na pozadí.
 *   '403':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/epsi_docs_synchronize_detail'
 *     description: Chybí oprávnění — ACL resource `EpsiDocs`, akce `synchronize`.
 *   '409':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/epsi_docs_synchronize_detail'
 *     description: Stahování stavové sady už běží — sledujte stavy v listingu.
 *   '502':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/epsi_docs_synchronize_detail'
 *     description: R46 dotaz na IS DMVS selhal — detail ve worklistu external_failures.
 * ```
 */
export const epsiDocsSynchronizeCreate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query?: EpsiDocsSynchronizeCreateQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<any>> => {
  const operation = epsiDocsSynchronizeCreateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'POST',
    request,
    onUploadProgress,
    cancelToken,
  );
};
